import { Form as FForm, Formik } from 'formik';
import React from 'react';
import { Button, Form, Modal, ModalProps } from 'react-bootstrap';
import { createModal } from 'react-modal-promise';

import { toastWarning } from '../../utils/toasts';
import { FieldDatepicker } from '../formik';

type Props = {
  readonly open: boolean;
  readonly close: (result: any) => void;
  readonly title?: string;
  /** body of dialog */
  readonly text?: string | React.ReactNode;
  /** accept text */
  readonly acceptText?: string;
  /** deny text */
  readonly denyText?: string;
  readonly type?: string;
  readonly init?: {
    readonly date: Date;
  };
} & ModalProps;

const ModalInput = ({
  open,
  close,
  title = 'Καθορίστε Ημερομηνία',
  text = '',
  acceptText = 'ΟΚ',
  denyText = 'ΑΚΥΡΩΣΗ',
  type = 'text',
  init,
}: Props) => {
  const handleOk = (values) => {
    if (values.date === null) {
      toastWarning('Πρέπει να επιλέξετε Ημερομηνία');
    } else {
      close(values);
    }
  };
  return (
    <>
      <Modal show={open} centered backdrop="static">
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{ date: init?.date ?? null }}
          onSubmit={(values) => {
            handleOk(values);
          }}
        >
          <Form as={FForm}>
            <Modal.Body>
              <br />
              <FieldDatepicker required label={'Ημερομηνία'} name="date" />
            </Modal.Body>
            <Modal.Footer>
              {/*  <Button variant="danger" onClick={() => close(false)}>
            {denyText}
          </Button> */}
              <Button variant="primary" type="submit">
                {acceptText}
              </Button>
              <Button variant="danger" onClick={() => close(false)}>
                {'ΑΚΥΡΩΣΗ'}
              </Button>
            </Modal.Footer>
          </Form>
        </Formik>
      </Modal>
    </>
  );
};

const promiseModalSelectDateOnly = createModal(ModalInput);

export default promiseModalSelectDateOnly;

